
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';

import TableListFooter from 'core/TableListFooter';
import Layout from 'components/Dashboard/Layout';
import { ListContext, ListProvider } from 'core/ListProvider';
import { YellowButton } from 'ui/Button';
import SearchWidget from 'form/SearchWidget';
import ChoiceListTable from './ListTable';
import {AsyncSelectButtonWidget} from "form/SelectButtonWidget";
import { UserContext, hasAccountPermission } from 'components/User';
import { ResponsiveTable } from 'ui/Table';
import { SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';


export default class ChoiceList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Значения';
  }

  onDetail = (item) => {
    this.props.history.push(`/catalog/choice/${item.id}`);
  };

  render() {
    return (
      <ListProvider
        url={'catalog/choice'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, permissions } = context;
            let addButton = undefined;
            if (hasAccountPermission(this.context, 'catalog.add_catalogchoice')) {
              let addUrl = '/catalog/choice/add';
              if (context.filter.type) {
                addUrl += `/?form[type]=${context.filter.type}`
              }
              addButton = (
                <YellowButton component={Link} to={addUrl} startIcon={<AddIcon />}>
                  Добавить значение
                </YellowButton>
              );
            }

            return (
              <Layout>
                <Layout.Header
                  title={'Значения'}
                  search={
                    <SearchWidget
                      value={context.filter.q}
                      onChange={(value) => context.setFilterValue('q', value)}
                    />
                  }
                  right={addButton}
                />
                <Layout.Filter>
                  <AsyncSelectButtonWidget
                    url={'catalog/choice/types'}
                    defaultOptions={[
                      {value: null, label: 'Все'}
                    ]}
                    value={context.filter.type}
                    optionValue={'value'}
                    optionLabel={'label'}
                    onChange={(value) => context.setFilterValue('type', value)}
                  />
                  <SelectButtonGroupWidget
                    value={context.filter.is_active}
                    options={[
                      {value: null, label: 'Все'},
                      {value: true, label: 'Активные'},
                      {value: false, label: 'Неактивные'},
                    ]}
                    onChange={(value) => context.setFilterValue('is_active', value)}
                  />
                </Layout.Filter>
                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <ChoiceListTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                        hasChangePermission={permissions.change}
                      />
                      <TableListFooter colspan={4} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
